import React from "react";
import { useTheme } from "../../hooks/ThemeContext";
import { useOrderMode } from "../../hooks/OrderModeContext";

// The venue paused online ordering (switch or dated closure — see
// StoreHoursService): a short banner with their note and when ordering is
// back. Otherwise, a quiet heads-up for a closure in the next few days.
// Renders nothing when there's nothing to say (incl. when the store-hours
// fetch failed — fail open).

const RED = "#e5484d";

type Props = {
  /** Text colour for the body (cart panels use cartTextColor). */
  textColor?: string;
  style?: React.CSSProperties;
  /** Also show the upcoming-closure heads-up (default true). */
  showNotice?: boolean;
};

const StorePauseBanner: React.FC<Props> = ({ textColor, style, showNotice = true }) => {
  const { theme } = useTheme();
  const { pause, closureNotice } = useOrderMode();
  const color = textColor || theme.textColor;

  if (pause) {
    const detail = [pause.reason, pause.back].filter(Boolean).join(" · ");
    return (
      <div
        role="status"
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "10px 14px",
          borderRadius: "12px",
          border: "1px solid rgba(229, 72, 77, 0.35)",
          backgroundColor: "rgba(229, 72, 77, 0.12)",
          color,
          lineHeight: 1.4,
          ...style,
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 700, color: RED }}>{pause.title}</div>
        {detail && <div style={{ fontSize: "13px", fontWeight: 500, marginTop: "2px", overflowWrap: "anywhere" }}>{detail}</div>}
        <div style={{ fontSize: "12px", opacity: 0.65, marginTop: "2px" }}>You can still browse the menu.</div>
      </div>
    );
  }

  if (showNotice && closureNotice) {
    return (
      <div
        role="note"
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "7px 12px",
          borderRadius: "10px",
          backgroundColor: "rgba(128, 128, 128, 0.12)",
          color,
          fontSize: "12.5px",
          fontWeight: 600,
          lineHeight: 1.4,
          overflowWrap: "anywhere",
          ...style,
        }}
      >
        {closureNotice}
      </div>
    );
  }

  return null;
};

export default StorePauseBanner;
